export const ERRORS = {
  couldNotUpdateProjects: 'Could not update projects',
  projectsUnavailable: 'Projects are currently unavailable',
  tryAgainLater: 'Please try again later',
}
